<template>
    <div class="adDialogLayer layer mask50" data-note="弹出式广告" v-show="visible">
        <div class="adDialog alignC">
            <div style="padding: 0 40px;">
                <bannerModule3 ref="adModule" @loadData="onLoadData" :itemCount="itemCount" :type="type" />
                <button class="icon closeButton" style="margin-top: 42px;" @click="visible=false"></button>
            </div>
        </div>
    </div>
</template>

<script>

import dialogPart from '../part/dialogPart';

import oneImageAdModule from './oneImageAdModule';
import bannerModule3 from './bannerModule3';

export default {
    name: "adDialog",
    extends : dialogPart,
    props : {
        itemCount : {
            type : Number,
            default : 1
        },
        type : {
            type : String,
            default : ''
        }
    },
    components : { bannerModule3 },
    methods : {
        loadAd(options, callback) {
            return this.$refs.adModule.loadAd(options, callback);
        },
        onLoadData(data) {

            if (data.length)
            {
                this.show();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.adDialogLayer {
    z-index: 10;
}
.adDialog {
    margin-top: 20%;

    img {
        max-width: 100%;
    }

    .closeButton {
        width: 34px;
        height: 34px;
        border: none;
        background-color: transparent;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAFIElEQVR4nO2cT0gjVxzHv9pLlY2L0G0XuuterC1tlUWrl7VbglRd64CXQsmhIMhCT8WD6LEmFnbpwf5BxC4kB6EHQ3DtQdI9ltollwShKF501l6EtRBdTejM5L0e8qaJ48SYmffeJJIv/C6SefP7fXzz5r33+80D5MkHoA3A+wD6APgBDAJ4AGCU2TD7mx9AL/ttG7u25vUa8sH0IR+o4tKGWVu3Wds1oxYAneAD4SI4H6LKe851AB8h3/VFgbDaKLvndQnxXVpNALohD0Ip62a+eKZGAO8AGIH3MEwbYT41CozbVs0A+l04Ltr6IbG3vAmxAyYvG2K+CtVtyB003doo81mIOqogQKfWXodx3jp4wbhTBcHwsja3MN5CbY0Z5WyUxeRITaiNt0mlNgwHr+RGVPc8w631o8LJ27tV4LRou/Qg2wzgsypwWLSNsFjLqtfJDXw+31gsFvtxY2Pjl66uri9kBRYIBB4mEonowsJC0MH1veVgtDp1LJlMPiWE5CiluePj47/9fv+XomGEQqFpXddfUUopIYQsLy9/56Cd1ouA9Dl1LpPJHNIiHR0d7YuEwmCcFt9zZ2fnmYO2SvaSFriYc2xvbz+jlJJiB9Pp9Ivx8fGveMMIBoMzuq6f0LMiKysr3ztobxQldt463TjZ3t7++cHBwaYVSjabPeQJZWlp6VtN006tMJLJ5JqLdrusMBrAYRLm8/nG9vf3n4uCEolEHhFCNCuMRCIRddn2ECzzkpu8/oOloGQymX/cQCkFY319/WdOvt8sBnKXFxATiqqqf9r0FEdQGAzdAoPG4/EnHP2+WwxkgCeQi6BkMpmKHh8GwxAMQ2EMAOQXOlxhFEPZ29vbIIRYobycmpqavAwMSqkMGKY1AcDbooCYUHZ3d3+nlOaKg9I07WR2dna61HWxWOwnyTAUxkLOQi6VSq1ZoRiGcRIKhc5BicfjT6wgKKU5wTAUxgI9MoAAUDY3N3+1jim6rp8WQ7GDQQjJhcPhxxJ87AaA+7KAFPWUM1AMwzgNhULTHsNQAHwMCHjDOIGSy+X+tYFhSIShMBYYkg0EgJJMJs9BscKIRCKPJPs1CHiYm02lUk9LQPEChsJYVB8Qj3rH/0Dqj0zBhgAPBlU7GIQQ20FVMpQBAPhEJoxSr91gMDhTYkImE8p9IF+S5BmMKpuY9QDAe6Jv5PP5xuym7rquVzJ1F72OURgL3BINQ1XVP6wwNE2zhWFaNBr9ge3iy4RyC5Cw/Lc+Jtls9uXk5OTX5a4Ph8OPqQfLf0DcBpEdjMOJiYmq3iAC6luICixbiFw3mVVV5b7zXgIKicfjQjaZG8EpDaGq6nPrlmENpCGGkU/FnFGnm0ZZouov3j3DaouLi0FrCpO6T1R1WmEALlOZW1tbv1lhpNPpF4FA4CEvGKbNzc3N2EFxkcpssQMCcEx2p9Np4cluwzCEJrsBd+UQa5RSgxBCZJZDaJpmJr2FlEMALgpmVldXPSuYmZ+f/8bB9WULZoB6SZWtrkLlcjmrqLK5XpZpo3rhro3qpd02ukrF/3fcwjB1FSqbuX0eYqqW3zzcYZhqQ22NKUI/MTP1BvI5UK+DLWeDzFcpeh3APcEBubF7zEepakD+2ay2D5k7YLPZI1NNkJjsusB64PGn7la1wrvDEMou4b3UNQAfQOzA+ym7xzVJMXFRA4AbyBfW88j7DLC2bsDjMYKXmlE4cqcXhSN3hlE4cucBCkfu9KFw5M6l9y3c6j8/155Tg+ES8QAAAABJRU5ErkJggg==');
        background-repeat: no-repeat;
    }
}
</style>
